import { render } from "./LCE26PerformanceView.vue?vue&type=template&id=12bbd11a"
import script from "./LCE26PerformanceView.vue?vue&type=script&lang=js"
export * from "./LCE26PerformanceView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__